/***
 * 下载excel权限设置
 ***/
// import http from "./http";
import Vue from 'vue';
import { Message, Notification } from "element-ui";
// Axios拦截请求并实现下载
import axios from 'axios'

const http = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
    timeout:5000*60
});


http.interceptors.response.use(
	response => {
	  return response.data;
	},
	error => {
	  console.log(error)
	  if (error && error.response) {
		switch (error.response.status) {
		  case 401:
		  case 403:
			Notification({
			  title: '提示',
			  message: '登录已失效，请刷新后重试',
			  type: 'error',
			  duration: 0
			});
			break;
		  default:
			break;
		}
	  }
	  return Promise.reject(error);
	}
  );


function ssopermission(urlpath,title){
	var xhr = new XMLHttpRequest();
    var formData = new FormData();
    xhr.open('get',urlpath); 
    xhr.responseType = 'blob';	
	console.log('xhr',xhr);	
	exportLoading=true;
	xhr.onload = function (e) {
        let blob = new Blob([xhr.response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'});
		let downloadElement = document.createElement('a');
		let href = window.URL.createObjectURL(blob); //创建下载的链接
		downloadElement.href = href;
		downloadElement.download = title+'.xlsx'; //下载后文件名
		document.body.appendChild(downloadElement);
		downloadElement.click(); //点击下载
		document.body.removeChild(downloadElement); //下载完成移除元素
		window.URL.revokeObjectURL(href); //释放掉blob对象     
		console.log('exportStatus',sessionStorage.getItem("exportStatus"));                
    };
    xhr.send(formData);
	
}


function postpermission(urlpath,title,excdata){
	var xhr = new XMLHttpRequest();
	console.log(excdata)
	var formData = new FormData();
	console.log(xhr)
	xhr.open('post',urlpath); 
	xhr.setRequestHeader("Content-Type","application/json"); 
    xhr.responseType = 'blob';		
	xhr.onload = function (e) {
        let blob = new Blob([xhr.response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'});
		let downloadElement = document.createElement('a');
		let href = window.URL.createObjectURL(blob); //创建下载的链接
		downloadElement.href = href;
		downloadElement.download = title+'.xlsx'; //下载后文件名
		document.body.appendChild(downloadElement);
		downloadElement.click(); //点击下载
		document.body.removeChild(downloadElement); //下载完成移除元素
		window.URL.revokeObjectURL(href); //释放掉blob对象                     
    };
	xhr.send(excdata);
}

//库存服务导出
export const exportStock = (exportType,code,language) => {
	return http({
	  method: "post",
	  headers: {
	     'Content-Type':'application/json',
	  },
	  responseType: 'blob',
	  url: process.env.VUE_APP_API_URL + `/stock/v2/getStockListExcel?exportType=${exportType}&code=${code}&language=${language}`
	});
};

export {
	ssopermission,
	postpermission
}